import { render, staticRenderFns } from "./AddBenefit.vue?vue&type=template&id=664f1b7c&scoped=true"
import script from "./AddBenefit.vue?vue&type=script&lang=js"
export * from "./AddBenefit.vue?vue&type=script&lang=js"
import style0 from "./AddBenefit.vue?vue&type=style&index=0&id=664f1b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f1b7c",
  null
  
)

export default component.exports